
import PermissionTable from "@components/Permission"

function Permission() {
  return <PermissionTable />;
}

export default Permission;
